"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _get = _interopRequireDefault(require("lodash/get"));
var _modalDecorator = _interopRequireDefault(require("../../hocs/modalDecorator"));
var _modalActions = require("../../redux/actions/modalActions");
var _orderFormTypes = require("../../constants/sendOrder/orderFormTypes");
var _orderEntryActions = require("../../redux/actions/orderEntryActions");
var _ConfirmLimitOrderModalComponent = _interopRequireDefault(require("./ConfirmLimitOrderModalComponent"));
var _instrumentPositionSelectors = require("../../redux/selectors/instrumentPositionSelectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state, modalProps) {
  var form = state.form;
  var level1 = state.apexCore.level1;
  var orderFormType = modalProps.orderFormType || _orderFormTypes.orderFormTypes["default"];
  var formObj = {};
  if (orderFormType === _orderFormTypes.orderFormTypes.advanced) {
    formObj = (0, _get["default"])(form, 'advancedOrderEntry.values', {});
  } else if (orderFormType === _orderFormTypes.orderFormTypes["default"]) {
    formObj = (0, _get["default"])(form, 'orderEntry.values', {});
  }
  var selectedInstrument = (0, _instrumentPositionSelectors.selectedInstrumentSelector)(state);
  var marketPrice = Object.keys(level1).length && (0, _get["default"])(level1, ["".concat(selectedInstrument.InstrumentId)], false) ? (0, _get["default"])(level1, [selectedInstrument.InstrumentId.toString(), 'BestOffer'], '0') : '0';
  return {
    orderFormType: orderFormType,
    formObj: formObj,
    limitPrice: formObj.limitPrice ? formObj.limitPrice.toString() : '',
    marketPrice: marketPrice,
    priceSymbol: selectedInstrument.Product2Symbol
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    confirmOrder: function confirmOrder(orderFormType, form) {
      return dispatch((0, _orderEntryActions.placeOrder)(orderFormType, form)).then(function () {
        if (orderFormType === _orderFormTypes.orderFormTypes.advanced) {
          dispatch((0, _orderEntryActions.clearOrderForm)('advancedOrderEntry'));
        } else {
          dispatch((0, _orderEntryActions.clearOrderForm)('orderEntry'));
        }
      });
    }
  };
};
var container = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_ConfirmLimitOrderModalComponent["default"]);
var _default = exports["default"] = (0, _modalDecorator["default"])({
  name: _modalActions.MODAL_TYPES.SUBMIT_LIMIT_ORDER
})(container);